import React, { useEffect, useState } from 'react'
import './CookieBar.css'

const STORAGE_KEY = 'myutiStickyBarClosed'

function getBottomValue(isOpen) {
  if (!isOpen) return '14px'
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768
  return isMobile ? '140px' : '80px'
}

function adjustGlassixPosition(isOpen) {
  if (typeof document === 'undefined') return
  const bottomValue = getBottomValue(isOpen)
  const oldStyle = document.getElementById('glassix-custom-position')
  if (oldStyle) oldStyle.remove()
  const style = document.createElement('style')
  style.id = 'glassix-custom-position'
  style.innerHTML = `
    #glassix-container #glassix-client #glassix-widget-launcher-container,
    #glassix-container #glassix-client #greeting-message-container {
      bottom: ${bottomValue} !important;
    }
  `
  document.head.appendChild(style)
}

export default function CookieBar() {
  const [showBar, setShowBar] = useState(false)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!sessionStorage.getItem(STORAGE_KEY)) {
      setShowBar(true)
      // next tick-like reveal for animation
      const t = setTimeout(() => setIsVisible(true), 100)
      adjustGlassixPosition(true)
      return () => clearTimeout(t)
    }
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return

    const handleResize = () => {
      if (!sessionStorage.getItem(STORAGE_KEY) && document.querySelector('#glassix-container')) {
        adjustGlassixPosition(true)
      }
    }

    window.addEventListener('resize', handleResize)

    // MutationObserver to detect Glassix mount
    const observer = new MutationObserver(() => {
      if (document.querySelector('#glassix-container')) {
        if (!sessionStorage.getItem(STORAGE_KEY)) adjustGlassixPosition(true)
        observer.disconnect()
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })

    // If Glassix already exists
    if (document.querySelector('#glassix-container') && !sessionStorage.getItem(STORAGE_KEY)) {
      adjustGlassixPosition(true)
    }

    return () => {
      window.removeEventListener('resize', handleResize)
      observer.disconnect()
    }
  }, [])

  const accept = () => {
    setIsVisible(false)
    setTimeout(() => {
      setShowBar(false)
      adjustGlassixPosition(false)
      if (typeof window !== 'undefined') {
        sessionStorage.setItem(STORAGE_KEY, 'true')
      }
    }, 400)
  }

  if (!showBar) return null

  return (
    <div id="sticky-bar" className={isVisible ? 'show' : ''}>
      <div className="sticky-content">
        <span>
          אתר זה עושה שימוש בקיבצי Cookies. למידע נוסף יש לעניין{' '}
          <a href="https://www.uti.co.il/terms/" target="_blank" rel="noreferrer">
            בתנאי השימוש ומדיניות הפרטיות
          </a>
        </span>
        <button onClick={accept} id="close-sticky">הבנתי</button>
      </div>
    </div>
  )
}


